
import styled from "styled-components"
import kamyonLight from "../../../../images/svg/colors/light/kamyoon-light.svg";
import kamyonDark from "../../../../images/svg/colors/dark/kamyoon-dark.svg";
import { CgMenu } from "react-icons/cg";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import notificationLight  from "../../../../images/svg/notification-light.svg"
import notificationDark  from "../../../../images/svg/notification.svg"
import { useDispatch } from "react-redux";
import { showModal } from "../../../../features/modal/modalSlice";
const Container = styled.div`

    width: 100%;
    height: ${({mobileTopMargin}) => mobileTopMargin};
    position: fixed;
    top: 0;
    background-color: ${({theme}) => theme.mainBgColor};
    z-index: 20;
    border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

    .wrapper{
        padding: 15px 30px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .menu-icon{
            font-size: 1.6rem;
            color: ${({theme}) => theme.mainTextColor};
        }

        .kamyoon-logo{
            width: 156px;
            height: 36px;

        }

        .img-notify{
            width: 30px;
        }
    }
    
` 

const TopbarMobile = () => {

    const {theme, mobileTopMargin} = useSelector(state => state.layout)
    const {modalType} = useSelector(state => state.modal)
    const path = useLocation().pathname
    const dispatch = useDispatch()

  return (
    <Container mobileTopMargin={mobileTopMargin}>
        <div className="wrapper">
            <CgMenu className="menu-icon" onClick={() =>  path !== "/" && dispatch(showModal(modalType === "mobile-menu" ? null : "mobile-menu"))}/>
            <Link to={"/"} className="logo-wrapper">
                <img
                    className="kamyoon-logo"
                    src={theme === "light" ? kamyonLight : kamyonDark}
                    alt="Kamyoon"
                />
            </Link>
            <img className="img-notify" src={theme === "light" ? notificationDark : notificationLight} alt="" />
        </div>
    </Container>
  )
}

export default TopbarMobile